<div [attr.data-limited-height]="!!maxHeight" class="border-0">
  <ul
    #listbox
    role="listbox"
    class="list-group fw-normal scrollbars list-box-group"
    [attr.aria-label]="ariaLabel"
    [attr.aria-labelledby]="ariaLabelledBy"
    [attr.aria-describedby]="ariaDescribedBy"
  >
    @for (option of options; track option; let i = $index) {
      <li
        class="d-flex list-group-item list-group-item-action cursor-pointer"
        role="option"
        tabindex="0"
        [ngClass]="{ active: option === selectedOption }"
        [attr.aria-selected]="option === selectedOption ? 'true' : undefined"
        (keydown)="onOptionKeyDown($event, option)"
        (click)="selectOption(option)"
      >
        <ng-container
          *ngTemplateOutlet="
            optionTemplate ?? optionLabelTemplate;
            context: { $implicit: option, index: i }
          "
        />
      </li>
    }
  </ul>
</div>

<ng-template #optionLabelTemplate let-option>
  {{ optionLabel(option) }}
</ng-template>
